import { createStyles, makeStyles } from '@mui/styles'

const useGlobalStyles = makeStyles(() => {
    return createStyles({
        '@global': {
            '.dark .bx-livechat-wrapper': {
                filter: 'invert(0.9)',
                color: 'black !important',
            },
            '.dark .bx-im-message-content-text': {
                filter: 'invert(0.9)',
                color: 'white',
            },
            '.dark .bx-livechat-title': {
                color: 'black',
                fontWeight: '600',
            },
            '.dark .b24-window-popup-wrapper': {
                filter: 'invert(0.9)',
            },
            '.dark .bx-livechat-body': {
                backgroundColor: 'white',
            },
            '.dark .bx-imopenlines-form-result-container': {
                filter: 'invert(1) brightness(1.3)',
            },
            '.dark .bx-imopenlines-form-result-title': {
                fontWeight: '600',
            },
            '.dark .bx-im-dialog-group-date': {
                color: 'black !important',
            },
            '.dark .bx-livechat-user-icon': {
                filter: 'invert(0.9)',
            },
            '.dark .bx-ui-smiles-smile-icon': {
                filter: 'invert(0.9)',
            },
            '.dark .bx-ui-smiles-set-icon': {
                filter: 'invert(0.9)',
            },
            '.b24-widget-button-block': {
                cursor: 'move',
            },
            '.b24-crm-button-icon': {
                cursor: 'pointer !important',
            },
            '*': {
                boxSizing: 'border-box',
                margin: 0,
                padding: 0,
            },
            html: {
                '-webkit-font-smoothing': 'antialiased',
                '-moz-osx-font-smoothing': 'grayscale',
                maxWidth: '100ddvw',
                maxHeight: '100dvh',
                overflow: 'clip',
            },
            body: {
                overflowX: 'hidden',
                fontFamily: 'Roboto, sans-serif',
                backgroundColor: '#f4f6f8',
            },
            '.dark body': {
                backgroundColor: '#0b1621',
            },
            a: {
                textDecoration: 'none',
            },
            'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button':
                {
                    '-webkit-appearance': 'none',
                    margin: 0,
                },
            'input[type=number]': {
                '-moz-appearance': 'textfield',
            },
            'input[type=hidden]': {
                display: 'none',
            },
            '.MuiDataGrid-filterForm': {
                padding: '1rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                '& select': {
                    padding: '0.5rem',
                },
                '& input': {
                    padding: '0.5rem',
                },
            },
            '.MuiDataGrid-root': {
                borderColor: 'divider',
            },
            '.MuiDataGrid-columnHeaders': {
                borderColor: 'divider',
            },
            '.MuiDataGrid-footerContainer': {
                borderColor: 'divider',
            },
            '.MuiDataGrid-cell': {
                borderColor: 'divider',
            },
            '::-webkit-scrollbar': {
                width: '0.5rem',
            },
            '::-webkit-scrollbar-thumb': {
                borderRadius: '0.375rem',
                borderWidth: '1px',
                backgroundColor: 'rgb(0 0 0 / 20%)',
            },
            '::-webkit-scrollbar-track': {
                backgroundColor: 'rgb(0 0 0 / 10%)',
            },
            '::-webkit-scrollbar-thumb:hover': {
                backgroundColor: 'rgb(0 0 0 / 30%)',
            },
            '.b24-widget-button-wrapper': {
                zIndex: 6,
            },
            '.b24-widget-button-shadow ': {
                zIndex: 5,
            },
            'input[type="time"]::-webkit-calendar-picker-indicator': {
                display: 'none',
                '-webkit-appearance': 'none',
            },
            'input[type="time"]': {
                '-moz-appearance': 'textfield',
            },
        },
    })
})

const GlobalStyles = () => {
    useGlobalStyles()
    return null
}

export default GlobalStyles
